import WhyTrees from './whyTrees'

export default WhyTrees